import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import EmpresasCreate from "./EmpresasCreate";
import axios from "axios";
import {
  Button,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
} from "reactstrap";
import Header from "../../../layout/Header/Header";
import Swal from "sweetalert2";

function ListadoEmpresas() {
  const { user } = useContext(AuthContext);
  const URL_EMPRESAS = process.env.REACT_APP_URL_EMPRESAS;
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const [empresas, setEmpresas] = useState([]);
  const [modal, setModal] = useState(false);
  const [name, setName] = useState("");
  const [rfc, setRfc] = useState("");
  const toggle = () => setModal(!modal);
  const [idEdit, setIdEdit] = useState();

  useEffect(() => {
    axios
      .get(URL_EMPRESAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        setEmpresas(response.data);
      })
      .catch((err) => console.log(err));
  }, []);

  function editEmpresa(event) {
    event.preventDefault();
    axios
      .patch(
        `${URL_EMPRESAS}/${idEdit}`,
        { name, rfc: rfc || "NA" },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        axios.post(
          URL_LOGS,
          { tipo: "Editar Empresa", detalle: name, user: user.id },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        );
        toggle();
        Swal.fire("Good job!", "Actualizado con exito", "success");
        window.location.reload();
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error?.response?.data || ""}`,
        });
        console.log(error);
      });
  }

  function jalaInfo(id, nombre, rfcE) {
    setName(nombre);
    setRfc(rfcE === "NA" ? "" : rfcE || "");
    setIdEdit(id);
    toggle();
  }

  return (
    <>
      <Header />
      <br />
      <br />
      <div className="container">
        {user.bancos ? (
          <div className="row">
            <div className="col-md-6 col-sm-6">
              <div className="card">
                <div className="card-body">
                  <h3 align="center">Empresas</h3>
                  <Table
                    size="sm"
                    striped
                    borderless
                    className="table-responsive-xl"
                  >
                    <thead>
                      <tr>
                        <th className="tituloTabla">Nombre</th>
                        <th className="tituloTabla">RFC</th>
                        <th className="tituloTabla">Editar</th>
                      </tr>
                    </thead>
                    <tbody>
                      {empresas
                        .filter((e) => e.is_active !== "No")
                        .sort((a, b) => (a.name > b.name ? 1 : -1))
                        .map((a) => (
                          <tr>
                            <td>{a.name}</td>
                            <td>{a.rfc}</td>
                            <td>
                              <Button
                                color="info"
                                size="sm"
                                onClick={() => jalaInfo(a._id, a.name, a.rfc)}
                              >
                                <i class="far fa-edit"></i>
                              </Button>
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </Table>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-sm-6">
              <div className="card">
                <div className="card-body">
                  <EmpresasCreate />
                </div>
              </div>
            </div>
          </div>
        ) : undefined}
      </div>
      <Modal size="sm" isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle}>Editar Empresa</ModalHeader>
        <ModalBody>
          <Label className="mr-sm-2">Nombre</Label>
          <Input
            className="col-sm-12"
            type="text"
            value={name}
            required
            onChange={(e) => setName(e.target.value)}
          />
          <Label className="mr-sm-2 mt-2">RFC</Label>
          <Input
            className="col-sm-12"
            type="text"
            value={rfc}
            onChange={(e) => setRfc(e.target.value)}
          />
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={editEmpresa}>
            Guardar
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
}

export default ListadoEmpresas;
